import React, { Component } from "react";
import { connect } from "react-redux";
import PipesPdfReport from "./pipePdfReport.component";
import MbPipesPdfReport from "./mb_pipePdfReport.component";
import ProjectSelectors from "../../reducers/project-reducer";

class pipesPdfReport extends Component{
    render() {
        const {
            lbl,
            unit,
            user,
            lang,
            content,
            pipeType,
            pipesCalc,
            projectInfo,
            pipeFitting,
            calculations,
            pipesTopCalc,
            projectDefault,
            porosityPercent,
            isMultiBed,
        } = this.props;

        return (
            ( !isMultiBed )
                ? <PipesPdfReport
                    lbl={lbl}
                    unit={unit}
                    user={user}
                    lang={lang}
                    content={content}
                    pipeType={pipeType}
                    pipesCalc={pipesCalc}
                    projectInfo={projectInfo}
                    pipeFitting={pipeFitting}
                    calculations={calculations}
                    pipesTopCalc={pipesTopCalc}
                    projectDefault={projectDefault}
                    porosityPercent={porosityPercent}
                />
                : <MbPipesPdfReport
                    lbl={lbl}
                    unit={unit}
                    user={user}
                    lang={lang}
                    content={content}
                    pipeType={pipeType}
                    pipesCalc={pipesCalc}
                    projectInfo={projectInfo}
                    pipeFitting={pipeFitting}
                    calculations={calculations}
                    pipesTopCalc={pipesTopCalc}
                    projectDefault={projectDefault}
                    porosityPercent={porosityPercent}
                />
        );
    }
}

const mapStateToProps = ( state ) => {
    return {
        lbl: state.localization.lbl,
        pipesTopCalc: state.pipeBed,
        pipesCalc: state.pipeGlobals,
        unit: state.localization.unit,
        lang: state.localization.lang,
        user: state.authentication.user,
        calculations: state.calculations,
        content: state.localization.content,
        projectDefault: state.project.project,
        projectInfo: state.project.projectInfo,
        pipeType: state.pipeGlobals.pipeType._name,
        pipeFitting: state.pipeGlobals.pipeFitting,
        porosityPercent: state.pipeGlobals.pipeStonePorosity,
        isMultiBed: ProjectSelectors.isMultiBedProject(),
    };
};

export default connect(
    mapStateToProps, null,
)(pipesPdfReport);



// WEBPACK FOOTER //
// ./src/components/PipesPDF/pipesPDF.container.js